// extracted by mini-css-extract-plugin
module.exports = {"section":"Gallery-module--section--2p2pV","photoWrapper":"Gallery-module--photoWrapper--16RmP","visible":"Gallery-module--visible--3V6eH","photo":"Gallery-module--photo--16w50"};